<template>
	<template-base class="containerCard">
		<div>
			<div v-if="accountClass.length && !showPaginationOnlyFooter" class="head-row mb-2 width-pagination-items">
				<div class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + accountClass.length }} de {{ pagination.count }}
					</label>
					<b-pagination
						class="mr-0 mb-2"
						id="page"
						v-model="currentPage"
						:total-rows="pagination.count"
						:per-page="pagination.limit.value"
					></b-pagination>
				</div>
				<b-form
					class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Itens por página
					</label>
					<b-form-select
						class="mr-0 mb-2"
						v-model="pagination.limit.value"
						name="itens-por-pagina"
						:options="optionsItensPorPag"
						@input="changeItensByPage()"
						:disabled="loading"
					/>
				</b-form>
			</div>
			<EditAccountClass
				v-if="modalEdit"
				:accountClassData="accountClassSelected"
				@closeModal="closeModal"
				@findAccountClass="findAccountClass"
			/>
		</div>
		<div>
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nofilters="true"
				name="accountClass"
				:hasPagination="true"
				:noedit="true"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_TIPOS')"
				:permissaoDelete="possuiPermissao('GER_D_TIPOS')"
				@clickDelete="confirmaApagar"
				@clickEdit="openEdit"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				:nosearch="false"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="openEdit"
				:hideBtnAdd="!possuiPermissao('GER_I_TIPOS')"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_TIPOS')"
				:permissaoDelete="possuiPermissao('GER_D_TIPOS')"
				@clickDelete="confirmaApagar"
				@clickEdit="openEdit"
				:selectItem="false"
				:globalAcoes="false"
				:colsDataCard="colsDataCard"
				:details="false"
				:showSelectItem="false"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="openEdit"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_TIPOS')"
			/>
		</div>
		<div v-if="accountClass.length && showPaginationOnlyFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
	</template-base>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";

	import { possuiPermissao } from "../../helpers/permissions";
	import { AccountClassService } from "../../services/accountClass";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import CardTransaction from "@/components/CardTransaction.vue";
	import emitter from "@/eventBus.js";
	import EditAccountClass from "./EditAccountClass.vue";

	export default {
		components: {
			TemplateBase,
			DataTable,
			CardTransaction,
			EditAccountClass
		},

		inject: ["parentValidator"],

		data () {
			return {
				modalEdit: false,
				accountClass: [],
				linhas: [],
				loading: true,
				accountClassService: new AccountClassService(),
				errMsg: "Nenhum tipo de contas cadastrada!",
				colunas: [
					"Tipo de Conta",
					"Fechamento Mensal",
					"Pago Automatico"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 50
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				sortTable: {
					sortBy: 0,
					order: 1,
					query: ""
				},
				isMobile: false,
				colsDataCard: {
					0: {
						idx: 0,
						label: "Tipo de Conta",
						textAlign: "left",
						cols: 12,
						visible: true
					},
					1: {
						idx: null,
						label: "",
						textAlign: "center",
						cols: 3,
						visible: false
					},
					2: {
						idx: 1,
						label: "Fechamento Mensal",
						textAlign: "center",
						cols: 6,
						visible: true
					},
					3: {
						idx: 2,
						label: "Pago Automatico",
						textAlign: "center",
						cols: 6,
						visible: true
					},
					4: {
						idx: 4,
						label: "",
						textAlign: "left",
						cols: 6,
						visible: false
					},
					5: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					},
					6: {
						idx: null,
						label: "",
						textAlign: "left",
						cols: 12,
						visible: false
					},
					7: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					}
				},
				showPaginationOnlyFooter: true
			};
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		created () {
			this.$validator = this.parentValidator;
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			this.findAccountClass();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findAccountClass();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findAccountClass();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findAccountClass();
			},

			async findAccountClass () {
				this.loading = true;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				const result = await this.accountClassService.listAccountClass({offset, limit, sortTable}) || {};
				this.accountClass = result.rows || [];
				this.linhas = result.rows.reduce((acc, gu) => [
					...acc,
					{
						idAccountClass: gu.idAccountClass,
						cols: [
							gu.description,
							gu.closeMonthly ? "Sim" : "Não",
							gu.automaticPay ? "Sim" : "Não"
						]
					}
				], []);

				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			async openEdit (item_) {
				let item = {};
				if (item_.idAccountClass)
					[ item ] = this.accountClass.filter(c => c.idAccountClass === item_.idAccountClass);

				this.accountClassSelected = item;
				this.modalEdit = true;
			},

			async confirmaApagar (item_) {
				const [ item ] = this.accountClass.filter((gu) => gu.idAccountClass === item_.idAccountClass);
				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja remover o tipo de conta?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.apagar(item.idAccountClass);
			},

			async apagar (idAccountClass) {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						await this.accountClassService.deleteAccountClass({idAccountClass});
						this.findAccountClass();
						emitter.emit("reloadAccount", { reload: true });

						return {
							title: "Sucesso!",
							body: "Tipo de conta deletada com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar o tipo de conta!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			newSearch (state) {
				this.sortTable.query = state.query;
				this.findAccountClass();
			},

			closeModal () {
				this.modalEdit = false;
			}
		}
	};
</script>

<style scoped>
	.toggle-tipo-conta {
		margin-top: 7px;
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 5rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.modal-edicao-label {
		font-family: 'Roboto Condensed Regular';
		font-size: 23px;
	}

	.modal-edicao-input {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.container-add-new-100 {
		width: 100% !important;
	}
</style>
